import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 2a7.5 7.5 0 0 0-7.127 5.157A2.5 2.5 0 0 0 1.5 9.5v3a2.5 2.5 0 0 0 5 0v-3a5.5 5.5 0 1 1 11 0v5A5.5 5.5 0 0 1 12 20a1 1 0 1 0 0 2 7.5 7.5 0 0 0 7.487-7.053Q19.736 15 20 15a2.5 2.5 0 0 0 2.5-2.5v-3a2.5 2.5 0 0 0-3.373-2.343A7.5 7.5 0 0 0 12 2m8 11a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 1-.5.5M3.5 9.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0zm6.664 4.753a1 1 0 0 0-1.328 1.494c1.878 1.67 4.45 1.67 6.328 0a1 1 0 0 0-1.328-1.494c-1.122.996-2.55.996-3.672 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }